<template>
  <div class="data-detail-container">
    <div class="data-detail-header">
      <div class="data-detail-header-left">
        <span style="color:#2A7EE3">{{ data.name }} </span>
        <el-rate v-model="data.averageScore" disabled></el-rate>
      </div>
      <div class="data-detail-header-right">
        <span style="display:flex;algin-item:center;" @click="collcet(data.id)"
          ><img
            src="@/assets/icon_collect.png"
            style="width:16px;height:16px;margin-right:10px"
            alt=""
          />收藏</span
        >
        <router-link :to="'/help/index'">
          <span style="display:flex;algin-item:center;"
            ><img
              src="@/assets/icon_error.png"
              style="width:16px;height:16px;margin-right:10px"
              alt=""
            />纠错</span
          >
        </router-link>
      </div>
    </div>

    <table class="data-detail-table">
      <tbody>
        <tr>
          <td class="frist-td">摘要:</td>
          <td colspan="3">{{ data.name }}</td>
        </tr>
        <tr>
          <td class="frist-td">数据领域</td>
          <td>{{ data.appTypeName }}</td>
          <td class="frist-td">申请接口</td>
          <td>
            <router-link
              :to="
                '/user/index?iface=' + data.id + '&dataset=' + data.datasetId
              "
            >
              <el-button type="primary">申请</el-button>
            </router-link>
          </td>
        </tr>
        <tr>
          <td class="frist-td">更新周期</td>
          <td>{{ data.updateCycle }}</td>
          <td class="frist-td">发布时间</td>
          <td>
            {{ data.createTime }}
          </td>
        </tr>
        <tr>
          <td class="frist-td">数据提供单位</td>

          <td>{{ data.companyName }}</td>

          <td class="frist-td">更新时间</td>
          <td>
            {{ data.lastUpdateTime }}
          </td>
        </tr>
        <tr>
          <td class="frist-td">访问次数</td>

          <td>{{ data.viewCount ? data.viewCount : 0 }}</td>

          <!-- <td class="frist-td">调用次数</td>
          <td>
           {{data.viewCount?data.viewCount:0}}
          </td> -->
          <td class="frist-td"></td>
          <td></td>
        </tr>
        <tr>
          <td class="frist-td">接口预览</td>

          <td>
            <router-link :to="'/interface/interface_preview/' + data.id">
              <el-button type="primary">预览</el-button>
            </router-link>
          </td>

          <td class="frist-td">数据量</td>

          <td>{{ data.dataCount ? data.dataCount : 0 }}</td>
        </tr>
        <tr>
          <td class="frist-td">数据预览：</td>
          <td>
            <router-link
              v-if="data.datasetId"
              :to="'/data_public/detail/data_preview/' + data.datasetId"
            >
              <el-button type="primary">预览</el-button>
            </router-link>
            <view v-else>无</view>
          </td>
          <td class="frist-td"></td>
          <td></td>
        </tr>
      </tbody>
    </table>

    <div class="data-detail-info-box">
      <el-tabs type="border-card" class="data-detail-info-box">
        <el-tab-pane label="总数接口">
          <el-form
            ref="form"
            class="padding-form"
            v-if="data.countInterfaceInfoVo"
          >
            <el-form-item label="接口地址：">
              {{ data.countInterfaceInfoVo.iAddress }}
            </el-form-item>

            <el-form-item label="支持格式：">
              {{ data.countInterfaceInfoVo.iType }}
            </el-form-item>

            <el-form-item label="请求方式：">
              {{ data.countInterfaceInfoVo.requestMethod }}
            </el-form-item>

            <el-form-item label="接口描述：">
              {{ data.countInterfaceInfoVo.summary }}
            </el-form-item>
            <el-form-item label="请求样例：">
              {{ data.countInterfaceInfoVo.requestExample }}
            </el-form-item>
          </el-form>
          <view class="table-box">
            <view class="title">请求参数</view>
            <view
              v-if="
                data.countInterfaceInfoVo &&
                  data.countInterfaceInfoVo.requestParameter
              "
              style=" text-align: center;"
            >
              <el-table
                border
                v-if="data.countInterfaceInfoVo.requestParameter.length != 0"
                :data="data.countInterfaceInfoVo.requestParameter"
                style="width: 100%"
              >
                <el-table-column align="center" prop="filedName" label="名称" />
                <el-table-column align="center" prop="dataType" label="类型" />
                <el-table-column align="center" prop="isNull" label="必填" />
                <el-table-column align="center" prop="dataDesc" label="描述" />
              </el-table>
              <view v-else>
                <span class="el-table__empty-text">暂无数据</span>
              </view>
            </view>
          </view>
          <view class="table-box">
            <view class="title">返回参数</view>
            <view
              v-if="
                data.countInterfaceInfoVo &&
                  data.countInterfaceInfoVo.reponseParameter
              "
              style=" text-align: center;"
            >
              <el-table
                border
                v-if="data.countInterfaceInfoVo.reponseParameter.length != 0"
                :data="data.countInterfaceInfoVo.reponseParameter"
                style="width: 100%"
              >
                <el-table-column align="center" prop="filedName" label="名称" />
                <el-table-column align="center" prop="dataType" label="类型" />
                <el-table-column align="center" prop="dataDesc" label="描述" />
              </el-table>
              <view v-else>
                <span class="el-table__empty-text">暂无数据</span>
              </view>
            </view>
          </view>
        </el-tab-pane>
        <el-tab-pane label="分页接口"
          ><el-form
            ref="form"
            class="padding-form"
            v-if="data.pageInterfaceInfoVo"
          >
            <el-form-item label="接口地址：">
              {{ data.pageInterfaceInfoVo.iAddress }}
            </el-form-item>

            <el-form-item label="支持格式：">
              {{ data.pageInterfaceInfoVo.iType }}
            </el-form-item>

            <el-form-item label="请求方式：">
              {{ data.pageInterfaceInfoVo.requestMethod }}
            </el-form-item>

            <el-form-item label="接口描述：">
              {{ data.pageInterfaceInfoVo.summary }}
            </el-form-item>
            <el-form-item label="请求样例：">
              {{ data.pageInterfaceInfoVo.requestExample }}
            </el-form-item>
          </el-form>
          <view class="table-box">
            <view class="title">请求参数</view>
            <view
              v-if="
                data.pageInterfaceInfoVo &&
                  data.pageInterfaceInfoVo.requestParameter
              "
              style=" text-align: center;"
            >
              <el-table
                border
                v-if="data.pageInterfaceInfoVo.requestParameter.length != 0"
                :data="data.pageInterfaceInfoVo.requestParameter"
                style="width: 100%"
              >
                <el-table-column align="center" prop="filedName" label="名称" />
                <el-table-column align="center" prop="dataType" label="类型" />
                <el-table-column align="center" prop="isNull" label="必填" />
                <el-table-column align="center" prop="dataDesc" label="描述" />
              </el-table>
              <view v-else>
                <span class="el-table__empty-text">暂无数据</span>
              </view>
            </view>
          </view>
          <view class="table-box">
            <view class="title">返回参数</view>
            <view
              v-if="
                data.pageInterfaceInfoVo &&
                  data.pageInterfaceInfoVo.reponseParameter
              "
              style=" text-align: center;"
            >
              <el-table
                border
                v-if="data.pageInterfaceInfoVo.reponseParameter.length != 0"
                :data="data.pageInterfaceInfoVo.reponseParameter"
                style="width: 100%"
              >
                <el-table-column align="center" prop="filedName" label="名称" />
                <el-table-column align="center" prop="dataType" label="类型" />
                <el-table-column align="center" prop="dataDesc" label="描述" />
              </el-table>
              <view v-else>
                <span class="el-table__empty-text">暂无数据</span>
              </view>
            </view>
          </view>
        </el-tab-pane>
        <el-tab-pane label="分页返回结果"
          ><el-form
            ref="form"
            class="padding-form"
            v-if="data.pageResultInterfaceInfoVo"
          >
            <el-form-item label="接口地址：">
              {{ data.pageResultInterfaceInfoVo.iAddress }}
            </el-form-item>

            <el-form-item label="支持格式：">
              {{ data.pageResultInterfaceInfoVo.iType }}
            </el-form-item>

            <el-form-item label="请求方式：">
              {{ data.pageResultInterfaceInfoVo.requestMethod }}
            </el-form-item>

            <el-form-item label="接口描述：">
              {{ data.pageResultInterfaceInfoVo.summary }}
            </el-form-item>
            <el-form-item label="请求样例：">
              {{ data.pageResultInterfaceInfoVo.requestExample }}
            </el-form-item>
          </el-form>
          <view class="table-box">
            <view class="title">请求参数</view>
            <view
              v-if="
                data.pageResultInterfaceInfoVo &&
                  data.pageResultInterfaceInfoVo.requestParameter
              "
              style=" text-align: center;"
            >
              <el-table
                border
                v-if="
                  data.pageResultInterfaceInfoVo.requestParameter.length != 0
                "
                :data="data.pageResultInterfaceInfoVo.requestParameter"
                style="width: 100%"
              >
                <el-table-column align="center" prop="filedName" label="名称" />
                <el-table-column align="center" prop="dataType" label="类型" />
                <el-table-column align="center" prop="isNull" label="必填" />
                <el-table-column align="center" prop="dataDesc" label="描述" />
              </el-table>
              <view v-else>
                <span class="el-table__empty-text">暂无数据</span>
              </view>
            </view>
          </view>
          <view class="table-box">
            <view class="title">返回参数</view>
            <view
              v-if="
                data.pageResultInterfaceInfoVo &&
                  data.pageResultInterfaceInfoVo.reponseParameter
              "
              style=" text-align: center;"
            >
              <el-table
                border
                v-if="
                  data.pageResultInterfaceInfoVo.reponseParameter.length != 0
                "
                :data="data.pageResultInterfaceInfoVo.reponseParameter"
                style="width: 100%"
              >
                <el-table-column align="center" prop="filedName" label="名称" />
                <el-table-column align="center" prop="dataType" label="类型" />
                <el-table-column align="center" prop="dataDesc" label="描述" />
              </el-table>
              <view v-else>
                <span class="el-table__empty-text">暂无数据</span>
              </view>
            </view>
          </view>
        </el-tab-pane>
        <el-tab-pane label="数据更新查询接口">
          <el-form
            ref="form"
            class="padding-form"
            v-if="data.searchUpdateInterfaceInfoVo"
          >
            <el-form-item label="接口地址：">
              {{ data.searchUpdateInterfaceInfoVo.iAddress }}
            </el-form-item>

            <el-form-item label="支持格式：">
              {{ data.searchUpdateInterfaceInfoVo.iType }}
            </el-form-item>

            <el-form-item label="请求方式：">
              {{ data.searchUpdateInterfaceInfoVo.requestMethod }}
            </el-form-item>

            <el-form-item label="接口描述：">
              {{ data.searchUpdateInterfaceInfoVo.summary }}
            </el-form-item>
            <el-form-item label="请求样例：">
              {{ data.searchUpdateInterfaceInfoVo.requestExample }}
            </el-form-item>
          </el-form>
          <view class="table-box">
            <view class="title">请求参数</view>
            <view
              v-if="
                data.searchUpdateInterfaceInfoVo &&
                  data.searchUpdateInterfaceInfoVo.requestParameter
              "
              style=" text-align: center;"
            >
              <el-table
                border
                v-if="
                  data.searchUpdateInterfaceInfoVo.requestParameter.length != 0
                "
                :data="data.searchUpdateInterfaceInfoVo.requestParameter"
                style="width: 100%"
              >
                <el-table-column align="center" prop="filedName" label="名称" />
                <el-table-column align="center" prop="dataType" label="类型" />
                <el-table-column align="center" prop="isNull" label="必填" />
                <el-table-column align="center" prop="dataDesc" label="描述" />
              </el-table>
              <view v-else>
                <span class="el-table__empty-text">暂无数据</span>
              </view>
            </view>
          </view>
          <view class="table-box">
            <view class="title">返回参数</view>
            <view
              v-if="
                data.searchUpdateInterfaceInfoVo &&
                  data.searchUpdateInterfaceInfoVo.reponseParameter
              "
              style=" text-align: center;"
            >
              <el-table
                border
                v-if="
                  data.searchUpdateInterfaceInfoVo.reponseParameter.length != 0
                "
                :data="data.searchUpdateInterfaceInfoVo.reponseParameter"
                style="width: 100%"
              >
                <el-table-column align="center" prop="filedName" label="名称" />
                <el-table-column align="center" prop="dataType" label="类型" />
                <el-table-column align="center" prop="dataDesc" label="描述" />
              </el-table>
              <view v-else>
                <span class="el-table__empty-text">暂无数据</span>
              </view>
            </view>
          </view>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div class="data-comment-box">
      <div class="comment-header">数据评论</div>
      <div class="comment-list">
        <div
          class="comment-item"
          v-for="(item, index) in remarkList"
          :key="index"
        >
          <div>Ip:{{ item.ipAddress }}</div>
          <div>{{ item.content }}</div>
          <div class="remake">
            <span>{{ item.time }}</span
            ><span>评分：{{ item.stars }}</span>
          </div>
          <div v-if="item.childenRemarks.length != 0" style="margin-top:0">
            <div>
              管理员回复：{{
                item.childenRemarks[0].content
                  ? item.childenRemarks[0].content
                  : ""
              }}
            </div>
            <div style="color:#a1a1a1;margin-top:10px">
              {{ item.childenRemarks[0] ? item.childenRemarks[0].time : "" }}
            </div>
          </div>
        </div>
      </div>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageData.curPageNumber"
        :page-sizes="pageData.pageSize"
        layout="total, sizes, prev, next, jumper"
        :total="pageData.total"
      >
      </el-pagination>
    </div>
    <remake type="IFACE" :subjectId="id" />
  </div>
</template>
<script>
import {
  getIfaceDetail,
  getDataItemList,
  getDataSetList,
  getRemark
} from "@/api/index";
import { collcet } from "@/api/user";
import remake from "@/components/remake/index";
export default {
  components: {
    remake
  },
  data() {
    return {
      commitList: [],
      data: {
        name: "",
        start: 5,
        id: 1
      },
      tableData: [],
      domainList: [],
      remarkList: [],
      pageData: {
        curPageNumber: 1,
        pageSize: 10,
        total: 0
      },
      id: ""
    };
  },
  created() {
    this.init();
  },
  methods: {
    refreshCode(code) {
      this.code = code;
    },
    async collcet(id) {
      let { message } = await collcet({
        refId: id,
        collectName: this.data.name,
        collectType: "DATAFACE"
      });
      this.$message({
        message: message,
        type: "success"
      });
    },
    onSubmit() {
      console.log(this.form, this.code);
      // remark({ type: "iface", subjectId: this.data.id });
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
    async init() {
      this.id = this.$route.params.id;
      var data = await getIfaceDetail({ id: this.$route.params.id });
      this.data = data.result;
      var data1 = await getDataItemList({ datasetId: this.$route.params.id });
      this.tableData = data1.result;

      var data2 = await getDataSetList({
        appTypeId: data.result.appTypeId,
        pageSize: 5
      });
      this.domainList = data2.result.data;
      var data3 = await getRemark({
        id: this.$route.params.id,
        type: "iface"
      });
      this.remarkList = data3.result.list;
      this.pageData.curPageNumber = data3.result.pager.curPageNumber;
      this.pageData.total = data3.result.pager.totalRecord;
      this.pageData.pageSize = data3.result.pager.pageSize;
    }
  }
};
</script>
<style lang="scss" scoped>
.data-detail-container {
  .padding-form {
    padding: 30px;
  }
  .table-box {
    display: flex;
    flex-direction: column;
    padding-bottom: 30px;
    .title {
      border: 1px solid #e5e5e5;

      font-size: 16px;
      font-weight: 500;
      padding: 10px 20px;
      background: #f5f5f5;
      color: #333333;
      font-weight: bolder;
    }
  }

  width: 100%;
  background: #ffffff;
  border: 1px solid #eeeeee;
  .data-comment-box {
    padding-bottom: 20px;
    .comment-list {
      font-size: 14px;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      margin-bottom: 30px;
      .comment-item {
        border-bottom: 1px dashed #e3e3e3;
        padding-bottom: 10px;
        > div {
          padding-left: 50px;
          margin-top: 10px;
          padding-right: 50px;
        }
        > .remake {
          font-size: 14px;
          font-weight: 400;
          color: #a1a1a1;
          line-height: 20px;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
        }
      }
    }
    .comment-header {
      height: 50px;
      background: #2a7ee3;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      line-height: 22px;
      display: flex;
      flex-direction: row;
      align-items: center;
      padding-left: 50px;
    }
  }
  .data-detail-info-box {
    margin-top: 30px;
    margin-bottom: 40px;
    min-height: 430px;
    .data-detail-info {
      display: flex;
      flex-direction: row;
      align-items: center;
      font-size: 14px;
      font-weight: 500;
      color: #ffffff;
      line-height: 20px;
      width: 100%;
      height: 50px;
      background: #2a7ee3;
      > div {
        width: 150px;
        height: 100%;
        text-align: center;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
      }
      > div:first-child {
        background: #239dfc;
      }
    }
  }

  .data-detail-table {
    width: 100%;
    border-spacing: 0 !important;
    font-size: 13px;
    font-weight: 400;
    color: #333333;
    line-height: 18px;
    border-top: 1px solid #eeeeee;
    border-bottom: 1px solid #eeeeee;
    td {
      border-right: 1px solid #eeeeee;
      border-bottom: 1px solid #eeeeee;
      height: 36px;
      padding-left: 15px;
    }
    tbody > tr > td:last-child {
      border-right: none;
    }
    tbody > tr:nth-child(even) {
      background: rgba(240, 240, 240, 0.3);
    }
    .frist-td {
      padding-left: 50px !important;
      width: 100px !important;
    }
  }
  .data-detail-header {
    padding: 0 215px 0 25px;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 16px;
    font-weight: 500;
    color: #2a7ee3;
    line-height: 22px;

    > div {
      display: inherit;
      span {
        margin-right: 30px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
    }
    .data-detail-header-right {
      span {
        margin-right: 0px;
        margin-left: 50px;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        line-height: 20px;
      }
    }
  }
}
</style>
